import clsx from "clsx";

import styles from "./MetricBar.module.scss";
import type { MetricBand } from "./bands";

interface MetricBarProps {
  /** Fill ratio 0..1. Clamped. Pass null for the "no data" empty state. */
  value: number | null;
  band: MetricBand | null;
  width?: number | string;
  className?: string;
  "data-tooltip-id"?: string;
  "data-tooltip-content"?: string;
}

const BAND_CLASS: Record<MetricBand, string> = {
  good: styles.bandGood,
  warn: styles.bandWarn,
  bad: styles.bandBad,
};

function isFiniteNumber(n: number | null): n is number {
  return typeof n === "number" && Number.isFinite(n);
}

export default function MetricBar({
  value,
  band,
  width = "100%",
  className,
  "data-tooltip-id": tooltipId,
  "data-tooltip-content": tooltipContent,
}: MetricBarProps) {
  const hasData = isFiniteNumber(value) && band !== null;
  const fillPct = hasData ? Math.max(0, Math.min(1, value)) * 100 : 0;

  return (
    <span
      className={clsx(
        styles.metricBar,
        !hasData && styles.metricBarEmpty,
        className,
      )}
      style={{ width }}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipContent}
    >
      {hasData && (
        <span
          className={clsx(styles.metricBarFill, BAND_CLASS[band])}
          style={{ width: `${fillPct}%` }}
        />
      )}
    </span>
  );
}
